import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cached", "always", "alwaysWrapper", "refreshWrapper"]

  connect() {
    this.sync()
  }

  sync() {
    const materialized = this.cachedTarget.checked

    if (materialized) this.alwaysTarget.checked = false
    this.alwaysTarget.disabled = materialized
    this.alwaysWrapperTarget.classList.toggle("opacity-50", materialized)
    this.alwaysWrapperTarget.classList.toggle("cursor-not-allowed", materialized)

    // Both clauses go into the materialized view's CREATE statement, so they
    // mean nothing on a regular view.
    if (this.hasRefreshWrapperTarget) {
      this.refreshWrapperTarget.classList.toggle("hidden", !materialized)
    }
  }
}
